import { Controller, ControllerProps, useFormContext } from 'react-hook-form'
import { Checkbox, FormControlLabel } from 'ui'
import { CheckboxProps } from 'ui/Checkbox/Checkbox'

export type DynamicFormCheckboxProps = {
  name: ControllerProps['name']
  label: React.ReactNode
  checkboxProps?: CheckboxProps & { 'data-testid'?: string }
}

// компонент react-hook-form с checkbox

export function FormInputCheckbox({
  name,
  label,
  checkboxProps,
}: DynamicFormCheckboxProps) {
  const form = useFormContext()

  return (
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={form.control}
          render={({ field }) => (
            <Checkbox
              {...checkboxProps}
              {...field}
              checked={field.value ?? false}
              onChange={(event, checked) => {
                field.onChange(checked)
                checkboxProps?.onChange?.(event, checked)
              }}
            />
          )}
        />
      }
      label={label}
    />
  )
}
